import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../../i18n/I18nContext";
import { api } from "../../lib/api";
import { Crown, Check } from "lucide-react";

export default function Memberships() {
  const { t, localize, fmtSAR, isAr } = useI18n();
  const [plans, setPlans] = useState([]);
  useEffect(() => { api.get("/memberships/plans").then((r) => setPlans(r.data)).catch(() => {}); }, []);
  return (
    <div className="mx-auto max-w-6xl px-4 py-12 sm:px-8">
      <div className="text-center">
        <Crown className="mx-auto h-10 w-10 text-[hsl(var(--brand-yellow))]" />
        <h1 className="mt-3 text-3xl font-bold text-slate-900 sm:text-4xl">{t("nav.memberships")}</h1>
        <p className="mt-2 text-slate-500">{isAr ? "وفّر أكثر مع باقات الجلسات والاشتراكات" : "Save more with session packs & subscriptions"}</p>
      </div>
      <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-3">
        {plans.map((p, i) => (
          <div key={p.id} data-testid={`plan-${p.id}`} className={`relative rounded-3xl border-2 bg-white p-7 ${i === 1 ? "border-primary shadow-xl" : "border-border"}`}>
            {i === 1 && <span className="absolute -top-3 start-6 rounded-full bg-[hsl(var(--brand-orange))] px-3 py-1 text-xs font-bold text-white">{isAr ? "الأكثر طلباً" : "Popular"}</span>}
            <h3 className="text-xl font-bold text-slate-900">{localize(p, "name")}</h3>
            <div className="mt-4 text-3xl font-extrabold text-primary">{fmtSAR(p.price)}</div>
            <ul className="mt-5 space-y-2 text-sm text-slate-600">
              <li className="flex items-center gap-2"><Check className="h-4 w-4 text-green-500" /> {p.sessions} {isAr ? "جلسة" : "sessions"}</li>
              <li className="flex items-center gap-2"><Check className="h-4 w-4 text-green-500" /> {isAr ? `صلاحية ${p.validity_days} يوم` : `${p.validity_days} days validity`}</li>
              <li className="flex items-center gap-2"><Check className="h-4 w-4 text-green-500" /> {isAr ? "رصيد جلسات قابل للاستخدام" : "Usable session credit"}</li>
            </ul>
            <Link to="/login" className={`mt-6 block rounded-full py-3 text-center font-semibold ${i === 1 ? "bg-primary text-white" : "border border-border text-slate-700"}`}>{isAr ? "اشترك" : "Subscribe"}</Link>
          </div>
        ))}
      </div>
      <p className="mt-8 text-center text-xs text-amber-600">{isAr ? "التجديد التلقائي يتطلب تفعيل بوابة الدفع (وضع تجريبي حالياً)" : "Auto-renewal requires an active payment gateway (currently demo mode)"}</p>
    </div>
  );
}
